module.exports = __webpack_public_path__ + "files/d888be64d490145f6007a6d967a3b5c7.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-5.png
// module id = 525
// module chunks = 76